// extracted by mini-css-extract-plugin
module.exports = {"titleListWrapper":"ou","titleListTabWrapper":"ov","tab":"ow","active":"ox"};